import { CostChart } from '../../costs/components/CostChart';
import { useCostChartRange } from '../../costs/useCostChartRange';
import { useLacTenantDailyCostsQuery } from '../queries/useLacTenantDailyCostsQuery';
import { useLacTenantMonthlyCostsQuery } from '../queries/useLacTenantMonthlyCostsQuery';

export type LacTenantCostChartProps = {
  tenantName: string;
  monthlyCostLimit?: number | null;
  yearlyCostLimit?: number | null;
  enabled?: boolean;
};

export function LacTenantCostChart({
  tenantName,
  monthlyCostLimit = null,
  yearlyCostLimit = null,
  enabled = true,
}: LacTenantCostChartProps) {
  const range = useCostChartRange();
  const dailyQuery = useLacTenantDailyCostsQuery({
    tenantName,
    fromDay: range.fromDay,
    toDay: range.toDay,
    enabled,
  });
  const monthlyQuery = useLacTenantMonthlyCostsQuery({
    tenantName,
    fromMonth: range.fromMonth,
    toMonth: range.toMonth,
    enabled,
  });

  return (
    <CostChart
      mode={range.mode}
      onModeChange={range.setMode}
      fromDay={range.fromDay}
      toDay={range.toDay}
      rangeLabel={range.rangeLabel}
      canGoNext={range.canGoNext}
      onPrev={range.goPrev}
      onNext={range.goNext}
      dailyQuery={dailyQuery}
      monthlyQuery={monthlyQuery}
      monthlyCostLimit={monthlyCostLimit}
      yearlyCostLimit={yearlyCostLimit}
    />
  );
}
